<template>
  <div id="iframe-container">
    <iframe
      :src="info.src"
      scrolling="yes"
      :width="iframeWidth"
      height="2000px"
      id="iframe"
    ></iframe>
  </div>
</template>
<script>
import { shareformatDateTime, cardType } from '@/utils/index';
import { plateList } from '@/api/base';
export default {
  metaInfo() {
    return {
      meta: this.metaData,
    };
  },
  data() {
    return {
      info: null,
      iframeWidth: '965px',
      metaData: [
        {
          name: 'viewport',
          content: 'width=device-width,height=device-height, viewport-fit=cover',
        },
      ],
    };
  },
  created() {
    document.title = this.$route.query.title;
    this.info = this.$route.query;
    this.info.src=decodeURIComponent(decodeURIComponent(this.info.src))
    if (this.IsPC()) {
      this.iframeWidth = '100%';
    } else {
      this.iframeWidth = '965px';
    }
    // this.info.src = this.info.src);
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    console.log(isiOS);
    if (isiOS || this.IsPC()) {
      window.location.href = this.info.src;
    }
    console.log(this.info);
    console.log(location.href);
    const el = isiOS ? document.documentElement : document.body;
    el.scrollTop = 0;
    // let obj = {
    //   filter: { sectionCode: null, field: 'id', types: null },
    //   query: {
    //     indexname: 'post',
    //     keyWords: Number(this.$route.query.postId),
    //     rows: 10,
    //     current: 1,
    //     scrollid: null,
    //     sort: 'disp',
    //   },
    // };
    // plateList(obj).then(res => {});
  },
  mounted() {
    let that = this;
    let info=this.info;
    let href=`${location.origin}/#/posts?date=${encodeURIComponent(info.date)}&author=${encodeURIComponent(info.author)}&type=${info.type}&src=${encodeURIComponent(encodeURIComponent(info.src))}&title=${encodeURIComponent(info.title)}`;
    console.log(href)
   setTimeout(function() {
      wx.ready(function() {
        let res = `${cardType(that.info.type)} ${
          that.info.date ? shareformatDateTime(that.info.date) : ''
        }\r\n`;
        let author = that.info.type == 4 && that.info.author ? `作者：${that.info.author}\r\n` : '';
        let descText = that.IsPC() ? '' : res + author + '公众号[一尘盯盘助手]';

        console.log(descText);
        wx.updateAppMessageShareData({
          title: that.info.title, // 分享标题
          desc: descText, // 分享描述
          link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
          success: function() {
            // 设置成功
          },
        });
        wx.updateTimelineShareData({
          title: that.info.title, // 分享标题
          desc: descText, // 分享描述
          link:href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
          success: function() {
            // 设置成功
          },
        });
      });
    }, 1000);
  },
  methods: {
    shareformatDateTime,
    cardType,
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod');
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
  },
};
</script>
<style scoped>
#iframe-container {
  background: #fff;
}
</style>
